/* eslint-disable no-param-reassign */
// TEMP Disable - just to get linting in
import _ from 'lodash';
import moment from 'moment-timezone';
import settings from 'settings';
import { TEMPLATE_TIMELINE as types } from 'actions/actionTypes';
import { templateToTimeline, TIMELINE_DAYS_TO_SHOW, TIMELINE_START_DATE } from 'selectors/timeline';
import { djangoDurationToMoment } from 'library/time';
import { message } from 'antd';

const { APP_CONFIG } = settings;

const initialState = {
  template: {
    name: '',
    id: null
  },
  groups: [{
    id: 0,
    title: 'New User'
  }],
  items: [],
  selected: [],
  inFlight: false,
  templatePinnedActivities: [],
};

const arrayToObject = array => array.reduce((obj, item) => {
  obj[item.id] = item;
  return obj;
}, {});

// NOTE: Does not return new groups. Works in place on items and groups params
const removeEmptyGroups = (items, groups) => {
  let index = 0;
  const indexToRemove = [];
  let nextGroupId = 0;
  while (index < groups.length) {
    const group = groups[index];
    const itemsInGroup = _.filter(items, i => i.group === group.id);
    // Empty group
    if (itemsInGroup.length === 0) {
      indexToRemove.push(index);
    }
    else {
      if (group.id !== nextGroupId) {
        // Reallocate items
        for (let i = 0; i < itemsInGroup.length; i++) {
          itemsInGroup[i].group = nextGroupId;
        }
        group.id = nextGroupId;
      }
      nextGroupId += 1;
    }
    index += 1;
  }
  for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
    groups.splice(indexToRemove[i], 1);
  }
};

const resetGroups = (items, groups) => {
  removeEmptyGroups(items, groups);
  for (let i = 0; i < groups.length; i += 1) {
    groups[i].title = `User ${groups[i].id + 1}`;
  }
  const maxGroupId = Math.max(...groups.map(g => g.id), -1);
  groups.push({
    id: maxGroupId + 1,
    title: 'New User'
  });
};

export const templateTimeline = (state = initialState, action) => {
  switch (action.type) {
  case types.REQUEST_IN_FLIGHT: {
    return {
      ...state,
      inFlight: true
    };
  }

  case types.SAVE_TEMPLATE_SUCCESS: {
    return { ...state, inFlight: false };
  }

  case types.SAVE_TEMPLATE_FAILURE: {
    return { ...state, inFlight: false };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.DELETE_ENTIRE_GROUP: {
    const { groupId } = action;

    const items = _.cloneDeep(state.items)
      .filter(i => i.group !== groupId);
    const groups = _.cloneDeep(state.groups);

    resetGroups(items, groups);
    return {
 ...state,
items,
      groups
};
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.NEW_TEMPLATE: {
    return { ...initialState, templatePinnedActivities: state.templatePinnedActivities };
  }

  case types.LOADED_TEMPLATE_SUCCESS: {
    const { items, groups, template } = templateToTimeline(action.data);
    // Add the template user to the returned group
    resetGroups(items, groups);
    return {
 ...state,
items,
      groups,
      template,
      inFlight: false
};
  }

  case types.LOADED_TEMPLATE_FAILURE: {
    return { ...state, inFlight: false };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.DELETE_TIMELINE_ACTIVITY: {
    // if there is currently a selected item, then delete it from state.
    // const items = _.cloneDeep(state.items);

    const newItems = state.items.filter(i => !state.selected.includes(i.id));
    const groups = _.cloneDeep(state.groups);

    resetGroups(newItems, groups);
    return {
 ...state,
items: newItems,
      groups
};
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.SELECT_TIMELINE_ACTIVITIES: {
    return { ...state, selected: action.ids };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ADD_ACTIVITY_TO_TIMELINE: {
    const {
      group, activity, time, createActivityCount, hoursBetween
    } = action;
    const items = _.cloneDeep(state.items);
    const groups = _.cloneDeep(state.groups);
    const assignedGroupId = Number(group);

    // Find the highest existing id and increment for a new id.
    // This seems easier than filling in the missing numbers in the array.
    const existingIds = items.map(i => i.id);
    const newItemId = Math.max(0, ...existingIds) + 1;

    // if multiple activities were specified.
    for (let i = 0; i < createActivityCount; i++) {
      const startTime = moment(time)
        .add(i * hoursBetween, 'hours');
      const activityDuration = djangoDurationToMoment(activity.duration);

      const endTime = moment(startTime)
        .add(activityDuration);

      const newItem = {
        id: newItemId + i,
        group: assignedGroupId,
        title: activity.name,
        start_time: startTime,
        end_time: endTime,
        itemProps: { style: { backgroundColor: activity.color } },
        color: activity.color,
        activity: { ...activity },
        default_notifications: activity.default_notifications,
        is_new: true
      };
      items.push(newItem);
    }
    resetGroups(items, groups);
    return {
 ...state,
items,
      groups
};
  }

  case types.UPDATE_ACTIVITIES: {
    const { items } = action;
    const currentItems = _.cloneDeep(state.items);

    items.forEach((newItem) => {
      const itemIndex = currentItems.findIndex(item => item.id === newItem.id);
      if (itemIndex !== -1) {
        currentItems[itemIndex] = newItem;
        currentItems[itemIndex].color = newItem.activity.color;
        currentItems[itemIndex].title = newItem.activity.name;
      }
    });
    return { ...state, items: currentItems };
  }

  case types.RESIZE_ACTIVITIES: {
    const { changes, items } = action;
    const currentItems = _.cloneDeep(state.items);

    const lookupItems = arrayToObject(currentItems); // setup the lookup table

    // loop through the items selected as filter returns
    // the selectedItem and not the state items
    // Avoiding looping through all state items
    const selectedItems = [];
    for (let i = 0; i < items.length; i += 1) {
      selectedItems.push(lookupItems[items[i].key]);
    }

    // update the selected items
    for (let i = 0; i < selectedItems.length; i += 1) {
      const currentItem = selectedItems[i];
      if (changes.isStartTimeChange) {
        const maxMinsAddable = currentItem.end_time.diff(currentItem.start_time, 'minutes') - APP_CONFIG.minActivityDurationMinutes;
        currentItem.start_time.add(Math.min(maxMinsAddable, changes.timeDelta), 'minutes');
      }
      else {
        const minMinsAddable = -1 * (currentItem.end_time.diff(currentItem.start_time, 'minutes') - APP_CONFIG.minActivityDurationMinutes);
        currentItem.end_time.add(Math.max(minMinsAddable, changes.timeDelta), 'minutes');
      }
      // add delta to duration to keep updated
      currentItem.activity.duration += changes.timeDelta;
    }

    return { ...state, items: currentItems };
  }

  case types.MOVE_ACTIVITIES: {
    const { changes, items } = action;

    const timelineStartDateBoundary = moment(TIMELINE_START_DATE);
    const timelineEndDateBoundary = moment(timelineStartDateBoundary)
      .add(TIMELINE_DAYS_TO_SHOW, 'day');
    const currentItems = _.cloneDeep(state.items);
    const currentGroups = _.cloneDeep(state.groups);

    let wasError = false;
    items.forEach((newItem) => {
      // Update time
      const currentItem = currentItems.filter(item => item.id === newItem.key)
        .pop();
      currentItem.start_time.add(changes.timeDelta, 'minutes'); // TODO: Validate inside boundries
      currentItem.end_time.add(changes.timeDelta, 'minutes'); // TODO: Validate inside boundries

      if (currentItem.start_time.valueOf() < timelineStartDateBoundary.valueOf()) {
        message.error('Activity moved before template start time');
        wasError = true;
        return;
      }

      if (currentItem.end_time.valueOf() > timelineEndDateBoundary.valueOf()) {
        message.error('Activity moved after template end time');
        wasError = true;
        return;
      }

      // Update Group
      const assignedGroupId = newItem.row;
      currentItem.group = assignedGroupId;
    });

    if (wasError) return state;
    resetGroups(currentItems, currentGroups);
    return {
 ...state,
items: currentItems,
      groups: currentGroups
};
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.REORDER_GROUP: {
    const { toGroupId, fromGroupId } = action;

    if (toGroupId === fromGroupId || toGroupId === -1) {
      return state;
    }

    const items = _.cloneDeep(state.items);

    const minGroupId = Math.min(toGroupId, fromGroupId);
    const maxGroupId = Math.max(toGroupId, fromGroupId);
    const incr = Math.sign(fromGroupId - toGroupId);

    const new_items = [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.group >= minGroupId && item.group <= maxGroupId) {
        if (item.group === fromGroupId) {
          item.group = toGroupId;
        }
        else {
          item.group += incr;
        }
      }
      new_items.push(item);
    }
    return { ...state, items: new_items };
  }

  case types.UPDATE_PINNED_ACTIVITIES: {
    return { ...state, templatePinnedActivities: action.activities };
  }

  default:
    return state;
  }
};
